import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft, faAnglesRight, faAnglesUp, faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { useIsMobile } from '../../../../helpers/window';

interface Props {
  open: boolean;
  panelWidthMax?: string;
  panelWidthMin?: string;
  collapseButton?: JSX.Element;
}

const FlexSidePanel: React.FC<Props> = ({
  open,
  panelWidthMin = '0',
  panelWidthMax = '100%',
  collapseButton,
  children,
}) => {
  const isMobile = useIsMobile();
  const [isCollapsed, setIsCollapsed] = React.useState(isMobile ? open : !open);
  const customArrowCollapsed = isMobile ? faAnglesUp : faAnglesLeft;
  const customArrowExpanded = isMobile ? faAnglesDown : faAnglesRight;

  return (
    <StyledLateralInfo
      className={`flexSidePanel shadow-lg ${isCollapsed ? 'mobileCtrlPanelWrapperCollapsed' : ''}`}
      style={{ width: isCollapsed ? panelWidthMin : panelWidthMax }}
    >
      <div
        className={`${isCollapsed ? 'panelCollapsed' : ''}`}
        style={{ width: isCollapsed ? panelWidthMin : panelWidthMax }}
      >
        {collapseButton ? (
          <div
            onClick={() => {
              setIsCollapsed(!isCollapsed);
            }}
            className="cursor-pointer"
          >
            {collapseButton}
          </div>
        ) : (
          <FontAwesomeIcon
            icon={isCollapsed ? customArrowCollapsed : customArrowExpanded}
            onClick={() => {
              setIsCollapsed(!isCollapsed);
            }}
            className={`cursor-pointer`}
          />
        )}

        {!isCollapsed && children}
      </div>
    </StyledLateralInfo>
  );
};

export default FlexSidePanel;

const StyledLateralInfo = styled.div`
  width: 100%;
  max-width: 38rem;
  transform: translate(1.5rem, -1.75rem);
  height: calc(100% + 1.75rem);
  background-color: #ffffff;

  .k-editor {
    border: none;
    width: 100%;
  }

  > div {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1.875rem;
    width: 38rem;
  }

  iframe {
    height: 100%;
  }

  svg {
    margin-top: 2rem;
    margin-left: -2rem;
    position: absolute;
    top: 0;
    left: 0;
  }

  .k-editor-content > .k-iframe {
    height: 100% !important;
  }

  .panelCollapsed {
    padding: 0;
  }
`;
